import { iconOverrides } from 'ag-grid-community';

export const fontAwesomeIcons = iconOverrides({
    type: 'font',
    family: 'Font Awesome 6 Pro',
    weight: '900',
    icons: {
        aggregation: '\u{f247}',
        arrows: '\u{f0b2}',
        asc: '\u{f062}',
        cancel: '\u{f057}',
        chart: '\u{f080}',
        checkboxChecked: '\u{f14a}',
        checkboxIndeterminate: '\u{f146}',
        checkboxUnchecked: '\u{f0c8}',
        colorPicker: '\u{f576}',
        columns: '\u{f0db}',
        contracted: '\u{f107}',
        copy: '\u{f0c5}',
        cross: '\u{f00d}',
        desc: '\u{f063}',
        expanded: '\u{f105}',
        eyeSlash: '\u{f070}',
        eye: '\u{f06e}',
        filter: '\u{f0b0}',
        first: '\u{f100}',
        grip: '\u{f58e}',
        group: '\u{f5fd}',
        last: '\u{f101}',
        left: '\u{f060}',
        linked: '\u{f0c1}',
        loading: '\u{f110}',
        maximize: '\u{f2d0}',
        menu: '\u{f0c9}',
        minimize: '\u{f2d1}',
        next: '\u{f105}',
        none: '\u{f338}',
        notAllowed: '\u{f05e}',
        paste: '\u{f0ea}',
        pin: '\u{f08d}',
        pivot: '\u{f074}',
        previous: '\u{f104}',
        radioButtonOff: '\u{f111}',
        radioButtonOn: '\u{f058}',
        right: '\u{f061}',
        save: '\u{f0c7}',
        smallDown: '\u{f107}',
        smallLeft: '\u{f104}',
        smallRight: '\u{f105}',
        smallUp: '\u{f106}',
        tick: '\u{f00c}',
        treeClosed: '\u{f105}',
        treeIndeterminate: '\u{f068}',
        treeOpen: '\u{f107}',
        unlinked: '\u{f127}'
    }
});
